<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>

            <!-- :style="{ backgroundImage: 'url(' + require(`@/assets/icons/${settings.icon}`) + ')' }" -->
            <div class="modal-icon" v-if="settings.icon" :style="getIconStyle()"></div>
            <h2 class="modal-title">{{ settings.title }}</h2>
            <div class="modal-message">{{ settings.message }}</div>

            <div class="hash__wrapper">
                <div class="modal-input" v-if="settings.input">
                    <label for="modal-input" v-if="settings.input.label">{{settings.input.label}}</label>
                    <b-form-input id="modal-input" type="text" :disabled="settings.input.disabled" :value="settings.input.value">{{settings.input.value}}</b-form-input>
                </div>
                <div class="copy__btn" @click="copyBtnClick">
                    {{translate('copy')}}
                </div>
            </div>


            <template v-slot:modal-footer>
                <div class="modal-footer__wrapper">
                    <b-button class="add_bot-btn" @click="addBotToGroup">
                        {{translate('telegramPopupGroup')}}
                    </b-button>
                    <b-button class="add_bot-btn" @click="addBotToPrivateChat">
                        {{translate('telegramPopupPrivate')}}
                    </b-button>
                    <div class="hash-available">
                        {{translate('telegramHashAvailable')}}
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";

    export default {
        name: "telegramBotPopup",
        data() {
            return {
                showInfoModal: !_.isEmpty(this.settings),
            }
        },
        watch: {
            settings(newValue) {
                this.showInfoModal = !_.isEmpty(newValue)
            }
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        methods: {
            async onClose() {
                this.showInfoModal = false
                if (this.settings.onCancelHandler) {
                    try {
                        await this.settings.onCancelHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },
            getIconStyle() {
                if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/icons/${this.settings.icon}`) + ')'
                    }
                } else {
                    return null
                }
            },
            addBotToGroup() {
                window.open( process.env.VUE_APP_TELEGRAM_BOT_LINK + this.settings.hash, '_blank')
            },
            addBotToPrivateChat() {
                window.open(process.env.VUE_APP_TELEGRAM_BOT_LINK_PRIVATE + this.settings.hash, '_blank')
            },
            copyBtnClick() {
                navigator.clipboard.writeText(this.settings.input.value)
            }
        }
    }
</script>

<style scoped>
    .hash__wrapper {
        display: flex;
        width: 100%;
        justify-content: space-around;
        align-items: baseline;
    }
    .copy__btn {
        background-color: #3F405C;
        padding: 12px 45px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        border-radius: 6px;
        cursor: pointer;
        color: white !important;
    }
    .add_bot-btn {
        background-color: #3F405C;
        padding: 12px 15px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        border-radius: 6px;
        cursor: pointer;
        color: white !important;
    }
    .form-control:disabled, .form-control[readonly] {
        background-color: #ffffff !important;
        opacity: 1;
    }
    .form-control {
        border-bottom: none !important;
    }
    .modal-input {
        width: 235px;
    }
    .modal-footer__wrapper {
        width: 100%;
    }
    .add_bot-btn {
        margin-bottom: 10px;
    }
    .hash-available {
        color: #2F2F2F;
        letter-spacing: 0;
        line-height: 22px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 22px;
        opacity: 0.8;
    }
    @media screen and (max-width: 426px) {
        .hash__wrapper {
            flex-direction: column;
            align-items: inherit;
        }
        .add_bot-btn {
            margin-bottom: 10px;
        }
        .modal-input {
            width: 100%;
        }
    }
</style>